import { getTimeDiffString } from '@src/data/utils';
import { useGiveawayUtils } from '@src/hooks/useGiveaways';
import { RaffleV2 } from 'jigsaw';
import { useEffect, useState } from 'react';
import { BiSolidTimeFive } from 'react-icons/bi';
import { HStack, Text } from 'ui_2';

type GiveawayTimeRemainingViewProps = {
  isGiveawayClosed?: boolean;
  isGiveawayOver?: boolean;
  isGiveawayWinner?: boolean;
  cutoff: Date;
  winnerCount: number;
};

export const GiveawayTimeRemainingView = ({
  isGiveawayClosed,
  isGiveawayOver,
  isGiveawayWinner,
  cutoff,
  winnerCount,
}: GiveawayTimeRemainingViewProps) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(new Date());
    }, 500);
    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
  }, []);

  return (
    <HStack className='w-max rounded-full bg-white px-1 py-[2px] shadow-md'>
      {isGiveawayClosed ? (
        <Text font='xs'>
          {isGiveawayOver
            ? isGiveawayWinner
              ? 'You won!'
              : `Closed - ${winnerCount} ${
                  winnerCount > 1 ? 'winners' : 'winner'
                }`
            : 'Closed'}
        </Text>
      ) : (
        <HStack className='w-fit items-center gap-1'>
          <BiSolidTimeFive className='text-gray-600' />
          <Text font='xs'>{getTimeDiffString(cutoff, now)}</Text>
        </HStack>
      )}
    </HStack>
  );
};

export const GiveawayTimeRemaining = ({ giveaway }: { giveaway: RaffleV2 }) => {
  const { isGiveawayClosed, isGiveawayOver, isGiveawayWinner } =
    useGiveawayUtils(giveaway);

  return (
    <GiveawayTimeRemainingView
      isGiveawayClosed={isGiveawayClosed}
      isGiveawayOver={isGiveawayOver}
      isGiveawayWinner={isGiveawayWinner}
      cutoff={giveaway.cutoff}
      winnerCount={giveaway.winnerCount}
    />
  );
};
